/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useQuery } from '@apollo/react-hooks';
import { Container, Table } from 'reactstrap';
import Button from 'reactstrap/lib/Button';
import {
  GET_RELATION_FEED, GET_RELATION_FEED_LENGTH,
} from '../../query/query';
import { shortFormatDate } from '../../services/format-utils';
import { LOVEBOX, SEND, POSTCARD } from '../../assets/Images';
import PrivacyPolicy from './privacy-policy';

const DisplayChannel = (channel = 'LOVEBOX') => {
  const [icon, setIcon] = useState();

  useEffect(() => {
    switch (channel) {
      case 'SHARED':
        setIcon(SEND);
        break;
      case 'POSTCARD':
        setIcon(POSTCARD);
        break;
      case 'LOVEBOX':
      default:
        setIcon(LOVEBOX);
        break;
    }
  }, [channel]);

  return (
    <img
      alt=""
      src={icon}
      width="40%"
    />
  );
};

const Message = ({
  date, senderUser: { firstName, email }, status, contentType = [], messagePrivacy, channel = 'LOVEBOX',
}) => (
  <tr>
    <td>{firstName}</td>
    <td>{email}</td>
    <td>{shortFormatDate(date)}</td>
    <td>{DisplayChannel(channel)}</td>
    <td>{status}</td>
    <td>{messagePrivacy}</td>
    <td>
      <ul>
        {contentType.map((type) => (<li key={type}>{type}</li>))}
      </ul>
    </td>
  </tr>
);

const getStatus = ({ status, channel, statusList }) => {
  if (
    !channel
    || channel === 'LOVEBOX'
    || (status && status.label === 'failed')
  ) { return status.label; }

  const newestStatus = statusList.reduce((last, current) => (
    moment(current.date).isBefore(moment(last.date)) ? last : current
  ));

  return newestStatus.label;
};

const RelationFeed = ({ userId, channelId }) => {
  const [allFetched, setAllFetched] = useState(false);
  const [messages, setMessages] = useState([]);
  const {
    loading, error, fetchMore, data: { savGetRelationFeed } = {},
  } = useQuery(
    GET_RELATION_FEED,
    {
      fetchPolicy: 'no-cache',
      variables: {
        userId, channelId,
      },
    },
  );

  const {
    data: { savGetRelationFeedLength: count } = {},
  } = useQuery(
    GET_RELATION_FEED_LENGTH,
    {
      fetchPolicy: 'no-cache',
      variables: {
        userId, channelId,
      },
    },
  );
  useEffect(() => setAllFetched(false), [channelId]);
  useEffect(() => setMessages((savGetRelationFeed || []).map((message) => ({
    ...message,
    status: getStatus(message),
  }))), [savGetRelationFeed]);

  const loadMore = async () => {
    await fetchMore({
      variables: {
        userId,
        channelId,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (fetchMoreResult
          && fetchMoreResult.savGetRelationFeed
          && fetchMoreResult.savGetRelationFeed.length < 15) {
          setAllFetched(true);
        }
        if (!fetchMoreResult || !(fetchMoreResult.savGetRelationFeed || []).length) {
          return prev;
        }
        return {
          savGetRelationFeed: [
            ...prev.savGetRelationFeed,
            ...fetchMoreResult.savGetRelationFeed,
          ],
        };
      },
    });
  };

  if (loading) {
    return <p>Loading...</p>;
  }
  if (error) {
    return <p>Error</p>;
  }

  if (messages.length === 0) {
    return (
      <tr>
        <td colSpan="5">
          There is no message in user feed
        </td>
      </tr>
    );
  }

  return (
    <Container>
      <h3>Relation Feed</h3>
      <PrivacyPolicy userId={userId} boxId={channelId} />
      <Table hover>
        <thead>
          <tr>
            <th>First Name</th>
            <th>Sender Email</th>
            <th>Date</th>
            <th>Channel</th>
            <th>Status</th>
            <th>Message Privacy</th>
          </tr>
        </thead>
        <tbody>
          {messages
            .sort(({ date: date1 }, { date: date2 }) => date2 - date1)
            .map((msg) => (
              <Message
                key={msg._id}
                contentType={msg.contentType}
                date={msg.date}
                status={msg.status}
                senderUser={msg.senderUser}
                messagePrivacy={msg.privacyPolicy}
                channel={msg.channel}
              />
            ))}
        </tbody>
      </Table>
      {!allFetched && (<Button onClick={loadMore}>Fetch More</Button>)}
      {` ${messages.length}/${count || 0}`}
    </Container>
  );
};

export default RelationFeed;



// WEBPACK FOOTER //
// ./src/components/user-info/relation-feed.js